// extracted by mini-css-extract-plugin
module.exports = {"disclaimer-text":"DisclaimerText--disclaimer-text--15Rlm","disclaimerText":"DisclaimerText--disclaimer-text--15Rlm"};